<template>
  <div
    id="order-info"
    v-if="cart_items_count"
    :class="{ guest: guest_checkout }"
  >
    <div id="checkout-bottom" class="cart-detail-box">
      <div
        class="cart-checkout p-0"
        v-if="currentStore && !currentStore.website_busy"
      >
        <div class="text-center" v-if="isFloorTableAvailable.table_id">
          <button @click="checkout()" class="btn btn-solid btn-block">
            {{ _T('Place Order') }}
          </button>
        </div>
        <div class="text-center" v-else>
          <button
            class="alert alert-danger d-block w-100"
            v-if="!selectedAddress && !guest_checkout"
          >
            {{ _T('Select delivery area') }}
          </button>
          <a
            v-if="deliveryTimeCalculate"
            href="javascript:void(0)"
            data-toggle="modal"
            class="btn btn-solid btn-block"
            @click="$bvModal.show('delivery-time-table')"
          >
            {{ _T('Checkout') }}
          </a>
          <a
            v-else
            href="javascript:void(0)"
            :class="{
              disabled:
                (!guest_checkout && !selectedAddress) || !cart_items_count,
            }"
            class="btn btn-solid btn-block"
            @click="$emit('checkout')"
          >
            {{ _T('Checkout') }}
          </a>
        </div>
      </div>
      <div class="cart-checkout p-0" v-else>
        <span class="text-danger">
          {{
            _T(
              '!Sorry we are unable to process your order because of heigh demand, please select another store'
            )
          }}.
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import Checkout from '@/mixins/Checkout'
export default {
  name: 'OrderInfoMobile',
  mixins: [Checkout],
  data() {
    return {
      enteredCustomerAddress: '',
    }
  },
  computed: {
    ...mapState({
      futureOrderDateTime: state => state.cart_store.futureOrderDateTime,
    }),
    ...mapState({}),
    selectedAddress() {
      const customerAddress = this.$store.state.customer_store.selectedAddress
      return customerAddress || this.enteredCustomerAddress
    },

    deliveryTimeCalculate() {
      if (this.futureOrderDateTime) {
        const current_date_store = new Date(this.currentDateTime.current_date)
        const current_date_active = new Date(
          this.futureOrderDateTime.future_date
        )
        if (current_date_active > current_date_store) {
          return false
        }
      }
      if (this.currentDateTime) {
        let time = this.deliveryTime(
          {
            delivery_duration: '0:' + this.currentDateTime.current_time,
          },
          true
        )

        let store_close_time = this.deliveryTime(
          {
            delivery_duration:
              '0:' + this.currentStore.delivery_hours.closes_at,
          },
          true
        )
        let openAt = parseInt(
          this.deliveryTime({
            delivery_duration: '0:' + this.currentStore.delivery_hours.opens_at,
          })
        )
        let closedAt = parseInt(
          this.deliveryTime({
            delivery_duration:
              '0:' + this.currentStore.delivery_hours.closes_at,
          })
        )
        if (openAt >= closedAt) {
          let timeSplit = this.currentStore.delivery_hours.closes_at.split(':')
          let calcTime = openAt + closedAt + 12 + (12 - openAt)
          store_close_time = calcTime * 60 + parseInt(timeSplit[1])
        }
        if (this.currentStore.delivery_hours.all_day_long) {
          store_close_time = 24 * 60
        }
        store_close_time =
          parseInt(store_close_time) -
          parseInt(this.deliveryTime(this.currentStore, true))
        let store_open_time = this.deliveryTime(
          {
            delivery_duration: '0:' + this.currentStore.delivery_hours.opens_at,
          },
          true
        )
        // store_open_time = parseInt(store_open_time) + parseInt(this.deliveryTime(this.currentStore, true))
        if (
          (time > store_open_time && time < store_close_time) ||
          (time < closedAt * 60 && time < store_close_time)
        ) {
          return false
        } else if (store_open_time > time) {
          if (this.futureOrderDateTime) {
            return false
          }
          return true
        }
        if (time > store_close_time) {
          return true
        } else return false
      } else return false
    },

    ...mapState({ driverTip: state => state.cart_store.driverTip }),
    ...mapGetters([
      'cart_items_count',
      '_T',
      'currentStore',
      'deliveryTime',
      'isFloorTableAvailable',
      'guest_checkout',
      'currentDateTime',
    ]),
  },
}
</script>
<style lang="scss" scoped>
@media (max-width: 575px) {
  #order-info {
    #checkout-bottom {
      min-height: $px170 !important;
      margin-bottom: $px60;
    }
    &.guest {
      #checkout-bottom {
        min-height: auto !important;
        margin-bottom: $px10;
      }
    }
  }
}
</style>
